// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + chunkId + "." + {"4239":"f20e3241","4280":"28944fa4","4879":"f20e3241"}[chunkId] + ".css";
};